export const isValidPasswordComplexity = (password: string): boolean => {
  return getPasswordComplexityErrorCode(password) === null;
};

export type PasswordComplexityErrorCode =
  | 'not_long_enough'
  | 'missing_lowercase'
  | 'missing_uppercase'
  | 'missing_digit'
  | 'missing_special_char'
  | 'extra_space';

export const getPasswordComplexityErrorCode = (
  password: string,
): PasswordComplexityErrorCode | null => {
  if (password.length < 8) {
    return 'not_long_enough';
  }

  if (!/[a-z]/.test(password)) {
    return 'missing_lowercase';
  }

  if (!/[A-Z]/.test(password)) {
    return 'missing_uppercase';
  }

  if (!/[0-9]/.test(password)) {
    return 'missing_digit';
  }

  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
    return 'missing_special_char';
  }

  if (!/^\S+.*\S+$/.test(password)) {
    return 'extra_space';
  }

  return null;
};
